import * as React from 'react';
import { Button, Modal } from 'react-bootstrap';

interface IUsefulDocumentsModalProps {
  documents: any;
}

interface IUsefulDocumentsModalStates {
  showModal: boolean;
}

export default class UsefulDocumentsModal
  extends React.Component<IUsefulDocumentsModalProps, IUsefulDocumentsModalStates> {
  public state = {
    showModal: false,
  };

  private handleCloseModal = () => {
    this.setState({
      showModal: false,
    });
  }

  private openModal = () => {
    this.setState({
      showModal: true,
    });
  }

  public render() {
    const { documents } = this.props;
    const { showModal } = this.state;
    return (
      <span>
        <Button
          className={'center green-background'}
          onClick={this.openModal}
        >
          <img src={require('../../img/document.svg')} alt="Useful Documents" className="contactUs-size"/>
        </Button>

        <Modal show={showModal} onHide={this.handleCloseModal} className="sidebar-modal-primary">
          <Modal.Header closeButton={true}>
            <div className="title-no-border">Useful Documents</div>
          </Modal.Header>
          <Modal.Body>
            <div className="docs-modal-container">
              <p>Please review the documents below in relation to your quote</p>
              {documents}
            </div>
          </Modal.Body>
        </Modal>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/components/UsefulDocumentsModal/index.tsx